// extracted by mini-css-extract-plugin
module.exports = {"knob":"Switch-module--knob--rld2d","slot":"Switch-module--slot--1g2FU"};